import { useTheme } from "@material-ui/core";
import * as React from "react";
import Tree, { SelectedValueProps } from "zq-ui-v3/components/Tree/Tree";
import { findAllParentValue, reduceByTree } from "zq-ui-v3/utils/tree";
import View from "zq-ui-v3/components/View/View";
import Button from "zq-ui-v3/components/Button/Button";
import Avatar from "zq-ui-v3/components/Avatar/Avatar";
import Resize from "zq-ui-v3/components/MoveResize/Resize";
import { useContext } from "zq-ui-v3/hooks/useContext";
import MenuOpenIcon from "@material-ui/icons/MenuOpen";
import MenuIcon from "@material-ui/icons/Menu";
import PageTitle from "./PageTitle";
import { useSelector } from "react-redux";
import ReplyIcon from "@material-ui/icons/Reply";
import { ErrorBoundary } from "@src/pages/ErrorBoundary";
// import useWebsocketStatus from "@src/hooks/useWebsocketStatus";
// import { Wifi, WifiOff } from "@material-ui/icons";

const env = process.env;
const selectValueFn = (v) => v.path || v._id;
const MainLayout: React.FC<any> = (props: any) => {
  const { children, history } = props;
  const [path, setPath] = React.useState(history?.location?.pathname);
  const [itemStatus, setItemStatus] = React.useState<{ [key: string]: SelectedValueProps }>({});
  const [itemList, setItemList] = React.useState<Array<string>>([]);
  const [showMenu, setShowMenu] = React.useState<boolean>(true);
  const { name } = useContext();
  const theme: any = useTheme();
  const profile = useSelector((state: any) => state.profile);
  const menus = useSelector((state: any) => state.profile?.menuTree);

  // const status = useWebsocketStatus();

  React.useEffect(() => {
    history.listen((location) => {
      console.log(location);
      setPath(location.pathname);
    });

    return () => {};
  }, [history]);

  const pageTitle = useSelector((state: any) => state.runtime.pageTitle);

  React.useEffect(() => {
    const list = findAllParentValue(profile.menuTree, selectValueFn, path).filter((v) => !!v);
    setItemList(list);
    const li = list.filter((v) => !!v);
    setItemStatus(
      li.reduce((re, v, index) => {
        re[v] = {
          _id: v,
          extend: true,
          itemSelected: index === li.length - 1 ? "selected" : "parent_selected",
        };
        return re;
      }, {}),
    );

    return () => {};
  }, [profile, path]);

  const menusMap = React.useMemo(
    () =>
      reduceByTree(
        menus,
        (re, v) => {
          re[v.path || v._id] = v;
          return re;
        },
        {},
      ),
    [menus],
  );
  console.log(pageTitle);

  return (
    <View className="w-100 h-100 overflow-hidden d-flex">
      {showMenu && (
        <Resize
          style={{
            width: 250,
            borderRight: `3px solid ${theme.palette.border.main}`,
            backgroundColor: "#efefef",
          }}
          type="e"
          borderStyle={`3px solid ${theme.palette.primary.main}`}
          className="d-flex flex-column flex-shrink-0"
        >
          <View
            className="flex-shrink-0 border-bottom p-1 pl-2 flex-shrink-0 h6 overflow-hidden bg-primary"
            style={{ height: "3rem" }}
          >
            {name || ""}
            <View Comp="span" className="text-secondaryText text-small pl-1">
              v{env.v}
            </View>
          </View>
          <View className="flex-grow-1 overflow-auto">
            <Tree
              itemStatus={itemStatus}
              items={profile.menuTree}
              showType="menu"
              nameField="title"
              valueFieldFn={(v: any) => v?.path || v?._id}
              className="w-100 h-100 px-1"
              onSelectItem={(e: any) => {
                if (e) history.push(e.path || e._id);
              }}
            />
          </View>
        </Resize>
      )}

      <View className="d-flex flex-column flex-grow-1 overflow-hidden">
        <View
          className="flex-shrink-0 border-bottom flex-shrink-0 con-center px-1"
          style={{ height: "3rem", backgroundColor: "#efefef" }}
        >
          <View className="con-center">
            {!showMenu && (
              <Button
                icon={<ReplyIcon fontSize="small" />}
                color="secondaryText"
                size="small"
                className="mr-1"
                onClick={() => history.goBack()}
              />
            )}
            <Button
              color={showMenu ? "secondaryText" : "primary"}
              icon={showMenu ? <MenuOpenIcon /> : <MenuIcon />}
              onClick={() => setShowMenu(!showMenu)}
            />

            <PageTitle
              title={pageTitle}
              className="flex-grow-1 px-1 con-center "
              menusMap={menusMap}
              itemList={itemList}
            />
          </View>
          <View className="flex-grow-1" />
          {/* 
          <Button
            color={status ? "success" : "error"}
            icon={status ? <Wifi /> : <WifiOff />}
            tooltip={status ? "正常连接" : "网络连接异常，请检查"}
          />
          
          */}
          <Avatar onClick={() => history.push("/profile")}>{profile.name}</Avatar>
        </View>
        <View className="flex-grow-1 overflow-auto">
          <ErrorBoundary>{children}</ErrorBoundary>
        </View>
      </View>
    </View>
  );
};
export default MainLayout;
